/**
 * apart from the main 'cart' reducer, this one is not cached in local storage and therefore it contains states, that should not be stored for longer time
 */

import {
    ADD_DISCOUNT,
    DISABLE_SUBMITED,
    EMPTY_CART,
    FETCH_MESSAGE_DESIGNS,
    SET_MESSAGE_PICKER
} from '../actions/actionTypes';

const INITIAL_STATE = {
    cartSubmitted: false,
    discount: null,
    messageDesigns: [],
    messagePicker: null
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case EMPTY_CART:
            return { ...state, cartSubmitted: true };

        case DISABLE_SUBMITED:
            return { ...state, cartSubmitted: false };

        case ADD_DISCOUNT:
            return { ...state, discount: action.payload };
        case SET_MESSAGE_PICKER:
            return { ...state, messagePicker: action.payload };
        case FETCH_MESSAGE_DESIGNS + '_FULFILLED':
            return { ...state, messageDesigns: action.payload.data };

        default:
            return state;
    }
}
